import React, { useState } from 'react';
import {
  Box,
  Typography,
  TableContainer,
  Table,
  TableHead,
  TableRow,
  TableCell,
  TableBody,
  Paper,
} from '@mui/material';
import { useMandates } from '../../contexts/MandateContext';

function MandateOverview() {
  const { mandates } = useMandates();
  const [orderBy, setOrderBy] = useState('name');
  const [orderDirection, setOrderDirection] = useState('asc');

  // Dans le groupement des mandats, ne garder que les utilisateurs avec des mandats actifs
  const groupedMandates = mandates.reduce((acc, mandate) => {
    if (!acc[mandate.name] && mandate.isActive) {  // Vérifier isActive avant de créer l'entrée
      acc[mandate.name] = {
        userId: mandate.users?.id,
        name: mandate.name,
        mandates: []
      };
    }
    if (mandate.isActive) {  // N'ajouter que les mandats actifs
      acc[mandate.name]?.mandates.push(mandate);
    }
    return acc;
  }, {});

  // Modifier la fonction qui formate les codes relève
  const formatUserMandates = (mandates) => {
    return mandates.map(m => (
      <Typography key={m.id} variant="body2" sx={{ mb: 0.5 }}>
        {m.releveCode}{m.role ? ` (${m.role})` : ''}
      </Typography>
    ));
  };

  const handleSort = (column) => {
    if (orderBy === column) {
      setOrderDirection(orderDirection === 'asc' ? 'desc' : 'asc');
    } else {
      setOrderBy(column);
      setOrderDirection('asc');
    }
  };

  return (
    <Box sx={{ display: 'flex', flexDirection: 'column', height: '100%' }}>
      <TableContainer component={Paper} sx={{ flex: 1 }}>
        <Table>
          <TableHead>
            <TableRow>
              <TableCell onClick={() => handleSort('name')}>Nom</TableCell>
              <TableCell>Codes Relève</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {Object.values(groupedMandates)
              .sort((a, b) => {
                const comparison = orderDirection === 'asc' ? 1 : -1;
                if (orderBy === 'name') {
                  return a.name.localeCompare(b.name) * comparison;
                }
                return 0;
              })
              .map(userMandates => (
                <TableRow key={userMandates.name}>
                  <TableCell>{userMandates.name}</TableCell>
                  <TableCell>
                    <Box sx={{ display: 'flex', flexDirection: 'column' }}>
                      {formatUserMandates(userMandates.mandates)}
                    </Box>
                  </TableCell>
                </TableRow>
              ))}
          </TableBody>
        </Table>
      </TableContainer>
    </Box>
  );
}

export default MandateOverview;
